import axios from "axios";

/**
 * Fetches the assistance
 *
 * @param {String} assistanceRequestId The assistance request identifier
 * @param {String} bearer The bearer token
 * @returns The assistance
 */
export const fetchAssistance = async (assistanceRequestId, bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_ASSISTANCE,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
        params: {
          id: assistanceRequestId,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Fetch the list of assistances
 * @param {String} bearer The bearer token
 * @returns The list of assistances
 */
export const fetchAssistances = async (bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_ASSISTANCE,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * Adds an attendee to the assistane
 * 
 * @param {String} externalUserId The external user identifier
 * @param {String} assistanceRequestId The assistance request identifier
 * @param {String} language The language
 * @param {String} bearer The bearer token
 * @returns The attendee added
 */
export const addAttendee = async (externalUserId, assistanceRequestId, language, bearer) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL_REST_API_ASSISTANCE}/${assistanceRequestId}/attendees`,
      {
        external_user_id: externalUserId,
        send_invitation: true,
        language,
      },
      {
        headers: {
          Authorization: `Bearer ${bearer}`
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * Fetches the e-call scenario
 * @param {*} scenarioId The scenario identifier
 * @param {*} bearer The bearer token
 * @returns The e-call scenario
 */
export const fetchScenario = async (scenarioId, bearer) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL_REST_API}/operators/scenarios/${scenarioId}/datas`,
      {
        headers: {
          Authorization: `Bearer ${bearer}`
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
}
